import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/stage.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ae.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/es.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/fr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ge.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/gr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ua.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/eur.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/usd.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/spinner.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/Developers/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Common/Loader/style.module.scss");
